import { computed, ref } from 'vue';
import { Order } from '@/models/Order';
import { useOrderStore } from '@/store/order/orderStore';
import { useAppStore } from '@/store/app/AppStore';

export function useOrderOverview() {
  const orderStore = useOrderStore();

  const selectedOrder = ref<Order | null>(null);
  const lastUpdatedTimestamp = ref<string>('');

  const closedOrders = computed(() => {
    return orderStore.closedOrders;
  });

  const groupedOpenOrders = computed(() => {
    return groupByDate([
      ...orderStore.activeOrders,
      ...orderStore.pendingOrders,
    ]);
  });

  const groupByDate = (orders: Array<Order>): Record<string, Array<Order>> => {
    return orders.reduce((acc: Record<string, Array<Order>>, obj: Order) => {
      const date = new Date(obj.appointment.start).toLocaleDateString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: 'numeric',
      });
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(obj);
      return acc;
    }, {});
  };

  const updateTimestamp = () => {
    lastUpdatedTimestamp.value = new Date().toLocaleDateString('de-DE', {
      hour: 'numeric',
      minute: 'numeric',
    });
  };

  const autoSelectFirstOrder = () => {
    if (
      !selectedOrder.value &&
      Object.keys(groupedOpenOrders.value).length > 0
    ) {
      selectedOrder.value =
        groupedOpenOrders.value[Object.keys(groupedOpenOrders.value)[0]][0];
    }
  };

  const cleanUpOldData = async () => {
    await useAppStore().cleanUpOldData();
  };

  return {
    selectedOrder,
    lastUpdatedTimestamp,
    closedOrders,
    groupedOpenOrders,
    updateTimestamp,
    autoSelectFirstOrder,
    cleanUpOldData,
    groupByDate,
  };
}
